var _style, _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.09449 60.09449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * { stroke-width: 0px; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.14632,
    y: 9.12143,
    width: 43.86898,
    height: 43.86898,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-13.14938 30.36641) rotate(-45)",
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72245,
    y: 8.39392,
    width: 40.66394,
    height: 40.66394,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-11.50954 29.6653) rotate(-45)",
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.81744,22.4734c-.0578-.00128-.1156.00018-.17328.00439h-8.86078v8.86853c0,1.10175-.90143,2.00317-2.00311,2.00317-1.10175,0-2.00317-.90143-2.00317-2.00317v-8.86853h-8.75256c-1.07306-.0506-1.98694.77185-2.04926,1.84436v14.75458c.06232,1.07245.9762,1.89496,2.04926,1.8443h21.51099c1.073.05066,1.98694-.77185,2.04919-1.8443v-14.75458c.02252-.9986-.76868-1.82623-1.76727-1.84875Z",
    fill: "#82368c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.18018,19.71796c.51172,0,1.02393-.19531,1.41406-.58594l2.25391-2.25391-.05707,5.60767h4.00037l.05621-5.55096,2.12012,2.15472c.3916.39795.9082.59717,1.42578.59717.50684,0,1.01367-.19141,1.40234-.57422.78809-.7749.79785-2.04102.02344-2.82861l-5.49371-5.58301-.00055-.00055-.00281-.00287c-.01135-.01154-.02496-.0191-.0365-.03027-.08289-.08032-.17053-.15564-.26636-.22083-.04132-.02808-.08618-.04724-.12909-.07184-.07043-.04065-.1394-.08319-.21497-.11517-.05017-.02118-.1026-.03259-.15399-.0495-.07239-.02393-.14325-.05115-.21912-.06677-.06873-.01416-.13873-.0163-.20837-.02319-.05908-.00586-.11591-.01898-.17639-.01959h-.021c-.06427,0-.125.01288-.18774.0188-.06329.00598-.12683.00696-.18951.01898-.01501.00287-.02991.00592-.0448.00909-.40558.0625-.79608.24414-1.10822.55664l-5.6001,5.6001c-.78125.78076-.78125,2.04736,0,2.82812.39014.39062.90234.58594,1.41406.58594Z",
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareUpIcon);
export default __webpack_public_path__ + "static/media/ShareUpIcon.661a46d2be39b1dd52333d22f47ad8b6.svg";
export { ForwardRef as ReactComponent };